import { Component } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { Color, getDynamicRouteLink, getNavigationGroup } from '@lsq-frontend/common-ui';
import { ClaimService, Icons } from '@lsq-frontend/common-ui';
import { combineLatest } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { SupplyChainPlatformRelationshipService } from '../../supply-chain/platform/relationship/relationship.service';
import { DashboardNavigationGroups } from '@lsq-frontend/fasttrack-shared/app-constants';

@Component({
    selector: 'mobile-settings-menu',
    template: `
        <div class="settings-menu">
            <div
                *ngFor="let navigationItem of navigationItems$ | async"
                class="settings-menu-option"
                [routerLink]="navigationItem.routerLinkUrl"
            >
                <div>
                    <h4>{{ navigationItem.label }}</h4>
                </div>
                <lsq-icon [type]="icons.ChevronRight" [color]="color.Gray"></lsq-icon>
            </div>
        </div>
    `,
    styleUrls: ['./mobile-settings-menu.component.scss']
})
export class MobileSettingsMenuComponent {
    public navigationItems$ = combineLatest(
        this._claimService.isOn(DashboardClaim.FinancingVendorPortal),
        this._claimService.isOn(DashboardClaim.FinancingPlatformEnrollment),
        this._claimService.isOn(DashboardClaim.FinancingBuyerPortal)
    ).pipe(
        withLatestFrom(this._supplyChainPlatformRelationshipService.platformId$),
        map(
            ([
                [isFinancingUser, isFinancingPlatformIntegrationUser, isBuyerPortalUser],
                platformId
            ]) => {
                if (isFinancingUser) {
                    return getNavigationGroup(atlas, DashboardNavigationGroups.ScfDirectSettings, {
                        absoluteLink: true
                    });
                } else if (isFinancingPlatformIntegrationUser) {
                    return getNavigationGroup(
                        atlas,
                        DashboardNavigationGroups.ScfPlatformSettings,
                        { absoluteLink: true }
                    ).map((navigationItem) => ({
                        ...navigationItem,
                        routerLinkUrl: getDynamicRouteLink(navigationItem.routerLinkUrl, {
                            platformId
                        })
                    }));
                } else if (isBuyerPortalUser) {
                    return getNavigationGroup(
                        atlas,
                        DashboardNavigationGroups.ScfBuyerPortalSettings,
                        { absoluteLink: true }
                    );
                }
                return getNavigationGroup(atlas, DashboardNavigationGroups.FactoringSettings, {
                    absoluteLink: true
                });
            }
        )
    );
    public icons = Icons;
    public color = Color;

    constructor(
        private _claimService: ClaimService,
        private _supplyChainPlatformRelationshipService: SupplyChainPlatformRelationshipService
    ) {}
}
